<template>
<!-- type	优惠类型，1：立减券，2：折扣券 -->
    <div class="c-tag"
        v-if="type==2">
        {{text}}折
    </div>
    <div class="c-tag"
        v-else-if="type==1">
        立减{{text}}
    </div>
    <div class="c-tag"
        v-else>
        {{text}}
    </div>
</template>
<style lang="scss" scoped>
.c-tag {
    display: inline-block;
    padding: 0 5px;
    height: 19px;
    background: $white;
    position: relative;
    color: $orange1;
    line-height: 19px;
    font-size: 10px;
    flex: none;
    background: url("https://oss.tuoxingwang.com/vaporetto-assets/common/coupon-left.png") 0 0 no-repeat,
        url("https://oss.tuoxingwang.com/vaporetto-assets/common/coupon-right.png") 100% no-repeat;
    background-size: auto 19px, auto 19px;
    &:before,
    &:after {
        content: "";
        position: absolute;
        z-index: 1;
        pointer-events: none;
        background-color: $orange1;
        height: 1px;
        left: 4px;
        right: 4px;
    }
    @media only screen and (-webkit-min-device-pixel-ratio: 2) {
        &:before {
            transform: scaleY(0.5);
            transform-origin: 50% 0;
        }
    }
    @media only screen and (-webkit-min-device-pixel-ratio: 2) {
        &:after {
            transform: scaleY(0.5);
            transform-origin: 50% 0;
        }
    }
    &:before {
        top: 0;
    }
    &:after {
        bottom: 0;
    }
}
</style>
<script>
export default {
    name: "CouponTag",
    props: ["type", "text"] //type==0 立减券 type==1 折扣券
};
</script>

